import st from "../../styles/template.module.scss";
import React from "react";

export default function Loader() {
    return (<div className={st.loader}>
        <div className={st.inner + ' ' + st.one}></div>
        <div className={st.inner + ' ' + st.two}></div>
        <div className={st.inner + ' ' + st.three}></div>
    </div>);
}